import React from 'react';
import { injectIntl } from 'react-intl';

import LoginContainer from '../../../apollo/containers/LoginContainer';


export default injectIntl(
  ({ intl }) => (
    <div>
      <h1 className="ui inverted header">{intl.formatMessage({ id: 'login.signIn' })}</h1>
      <LoginContainer
        title={intl.formatMessage({ id: 'login.enter' })}
        errorTitle={intl.formatMessage({ id: 'login.error' })}
        forgottenLinkText={intl.formatMessage({ id: 'login.text.forgottenLink' })}
        passwordLabel={intl.formatMessage({ id: 'login.label.password' })}
        emailNotValidMessage={intl.formatMessage({ id: 'login.error.email' })}
        forgottenLink="/login/forgot"
      />
    </div>
  )
);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/pages/login/form/index.js
 **/